export default __webpack_public_path__ + "static/media/Notification Configuration.578c9f8d.svg";